module.exports = __webpack_public_path__ + "static/media/p16-events.2b7d4019.csv";